<template>
  <component :is="tag" :class="[classes, { '--display': displayFont }]" data-comp="a-header">
    <slot />
  </component>
</template>

<script setup>
defineProps({
  tag: {
    type: String,
    default: "h1",
    validator(value) {
      return ["h1", "h2", "h3", "h4", "h5", "h6", "p", "div", "span"].includes(value);
    },
  },
  // size: {
  //   type: String,
  //   validator(value) {
  //     return ["", "xl", "l", "m", "s", "xs"].includes(value);
  //   },
  //   default: "",
  // },
  classes: {
    type: String,
    default: "",
  },
  displayFont: {
    type: Boolean,
    default: false,
  },
});
</script>

<style lang="scss">
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: var(--font-family);
  &.--display {
    font-family: var(--font-family-display);
  }
}
h1,
.h1 {
  font-size: var(--font-size-h1);
  letter-spacing: -0.025em;
  line-height: var(--line-height-h1);
  font-weight: var(--font-weight-book);
}
h2,
.h2 {
  font-size: var(--font-size-h2);
  line-height: var(--line-height-h2);
  font-weight: var(--font-weight-book);
}
h3,
.h3 {
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
  font-weight: var(--font-weight-book);
}
h4,
.h4 {
  font-size: var(--font-size-h4);
  line-height: var(--line-height-h4);
  font-weight: var(--font-weight-book);
}
.h5 {
  font-size: global.clampRem(calc(1rem * 1.15), calc(1rem * 1.25));
  font-weight: var(--font-weight-book);
  line-height: 1.2;
}
.h6 {
  font-size: 1rem;
  font-weight: var(--font-weight-book);
  line-height: 1.2;
}
</style>
